import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=b7e2b6b0"
import script from "./ProfileCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=b7e2b6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports